import { css, styled } from '@zeiss/beyond-online-react';

interface ButtonGridProps {
  children: React.ReactNode;
  desktopColumnCount: number;
  desktopXXLbuttonMaxWidth?: string;
  mobileColumnCount: number;
  tabletColumnCount: number;
}

interface ContainerProps {
  $desktopColumnCount: ButtonGridProps['desktopColumnCount'];
  $desktopXXLbuttonMaxWidth?: ButtonGridProps['desktopXXLbuttonMaxWidth'];
  $mobileColumnCount: ButtonGridProps['mobileColumnCount'];
  $tabletColumnCount: ButtonGridProps['tabletColumnCount'];
}

const ButtonGridContainer = styled.div<ContainerProps>`
  display: grid;
  grid-template-columns: ${({ $mobileColumnCount }) =>
    `repeat(${$mobileColumnCount}, 1fr)`};
  gap: var(--spacing-xs);
  place-items: center center;
  outline: none;

  > button {
    width: 100%;
  }

  @media (width >= 768px) {
    grid-template-columns: ${({ $tabletColumnCount }) =>
      `repeat(${$tabletColumnCount}, 1fr)`};
  }

  @media (width >= 1024px) {
    grid-template-columns: ${({ $desktopColumnCount }) =>
      `repeat(${$desktopColumnCount}, 1fr)`};
  }

  ${({ $desktopXXLbuttonMaxWidth }) =>
    $desktopXXLbuttonMaxWidth &&
    css`
      @media (width >= 1440px) {
        grid-template-columns: repeat(
          auto-fill,
          minmax(4rem, ${$desktopXXLbuttonMaxWidth})
        );
      }
    `};
`;

/**
 * Place buttons in a grid.
 *
 * Based on Beyond's `SelectButtonGroup` with additional breakpoints and limits.
 */
export const ButtonGrid = ({
  children,
  desktopColumnCount,
  desktopXXLbuttonMaxWidth,
  mobileColumnCount,
  tabletColumnCount,
}: ButtonGridProps) => {
  return (
    <ButtonGridContainer
      $desktopColumnCount={desktopColumnCount}
      $desktopXXLbuttonMaxWidth={desktopXXLbuttonMaxWidth}
      $mobileColumnCount={mobileColumnCount}
      $tabletColumnCount={tabletColumnCount}
    >
      {children}
    </ButtonGridContainer>
  );
};
